<template>
  <TenantGrid>
    <template v-slot:content>
      <div class="content-wrapper">
        <TenantHeader />

        <p class="subtitle">
          Selecione as condições de pagamento desejadas:
        </p>

        <h3 class="title">
          Entrada
        </h3>

        <DownPaymentList
          class="down-payment-list"
          :loadingValues="downPaymentValueSkeleton"
          :indexSelected="downPaymentIndexSelected"
          @downPaymentChange="onDownPaymentChange"
          :downPaymentOptions="downPaymentOptions"
          version="v2"
        />

        <h3 class="title">
          Parcelamento
        </h3>

        <InstallmentOptionListV2
          :loadingValues="installmentsSkeleton"
          :indexSelected="installmentIndexSelected"
          :installmentOptions="installmentOptions"
          @installmentChange="onInstallmentChange"
        />

        <div class="content-footer-button hide-on-large">
          <Button
            class="primary"
            @click="() => $router.push('/locatario/sumario')"
          >
            Continuar
          </Button>
        </div>
      </div>
    </template>

    <template v-slot:drawer>
      <div class="payment-info-wrapper">
        <div>
          <div class="payment-info">
            <p class="body-regular gray-700">
              Valor do título
            </p>
            <p class="body-bold gray-700">
              {{ proposal.value | moneyFilter }}
            </p>
          </div>

          <Divisor class="payment-info-divisor" />

          <div class="payment-info">
            <p class="body-regular gray-700">
              Entrada
            </p>
            <p class="body-bold gray-700">
              {{ selectedDownpaymentOption
              && selectedDownpaymentOption.downPaymentValue | moneyFilter }}
            </p>
          </div>

          <Divisor class="payment-info-divisor" />

          <div class="payment-info">
            <p class="body-regular gray-700">
              Parcelas
            </p>
            <p class="body-bold gray-700">
              {{ paymentInstallments | moneyFilter }}
            </p>
          </div>

          <Divisor class="payment-info-divisor" />

          <div class="payment-info">
            <p class="body-regular gray-700">
              Valor total
            </p>
            <p class="body-bold gray-700">
              {{ totalAmount | moneyFilter }}
            </p>
          </div>

        </div>
        <Button
          class="primary"
          :disabled="selectedOption === null"
          @click="() => $router.push('/locatario/sumario')"
        >
          Continuar
        </Button>
      </div>

    </template>
  </TenantGrid>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Button from '@/components/ui/AppButton.vue';
import Divisor from '@/components/common/Divisor.vue';
import DownPaymentList from '@/components/common/DownPaymentList.vue';
import InstallmentOptionListV2 from '@/components/common/InstallmentOptionListV2.vue';
import TenantGrid from '../components/TenantGrid.vue';
import TenantHeader from '../components/TenantHeader.vue';
import stringMixin from '../../../mixins/string';

export default {
  name: 'tenantPaymentOptions',
  metaInfo: {
    title: 'Opções de Pagamento',
  },
  components: {
    TenantGrid,
    InstallmentOptionListV2,
    DownPaymentList,
    TenantHeader,
    Button,
    Divisor,
  },
  mixins: [stringMixin],
  computed: {
    ...mapState('tenant', ['proposal']),
    downPaymentOptions() {
      return this.proposal.downPaymentOptions.map((option) => ({
        downPaymentValue: option.downPaymentValue,
        downPaymentPercentage: option.downPaymentPercentage,
        economyValue: option.economyValue,
      }));
    },
    installmentOptions() {
      if (!this.selectedDownpaymentOption) {
        return [];
      }
      return this.selectedDownpaymentOption.options.map((option) => ({
        installments: option.numberOfInstallments,
        value: option.paymentInstallments,
        interest: option.interestRatePM,
        total: option.totalAmount,
      }));
    },
    totalAmount() {
      return this.selectedOption && this.selectedOption.totalAmount;
    },
    paymentInstallments() {
      return this.selectedOption && this.selectedOption.paymentInstallments;
    },
  },
  data: () => ({
    selectedDownpaymentOption: null,
    selectedOption: null,

    downPaymentValueSkeleton: false,
    downPaymentIndexSelected: null,

    installmentsSkeleton: false,
    installmentIndexSelected: null,
    debouceTimeout: null,
  }),
  methods: {
    ...mapActions('tenant', ['setDownPaymentOption']),
    onDownPaymentChange(index) {
      this.downPaymentIndexSelected = index;
      this.selectedDownpaymentOption = this.proposal.downPaymentOptions[index];
      this.selectedOption = null;
      this.installmentIndexSelected = null;
      this.skeletonDebounce();
    },
    onInstallmentChange(index) {
      this.installmentIndexSelected = index;
      this.selectedOption = this.selectedDownpaymentOption.options[index];
      this.setDownPaymentOption(this.selectedOption);
    },
    openDetails() {
      this.$router.push('/locatario/detalhes');
    },
    skeletonDebounce() {
      this.installmentsSkeleton = true;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        this.installmentsSkeleton = false;
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
  .content-wrapper {
    margin-top: 24px;
  }

  .subtitle {
    @extend .body-regular;
    color: var(--gray-500);
    margin: 16px 0 20px 0;
  }

  .title {
    color: var(--gray-700);
    margin-bottom: 16px;
  }

  .down-payment-list {
    margin-bottom: 24px;
    display: flex;
    gap: 20px;
  }

  .payment-info-wrapper {
    box-sizing: border-box;
    padding: 36px;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .payment-info-divisor {
    margin: 16px 0;
  }

  .payment-info {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @media (max-width: $breakpoint-large) {
    .content-wrapper {
      margin: 24px;
    }

    .content-footer-button {
      margin-top: 20px;
      width: 100%;

      button {
        height: 48px;
        width: 100%;
      }
    }
  }
</style>
